// #region Import
import axios from "axios";
// #endregion
export default class ApiManager {
    // #region Vars
    _api;
    _sts;
    _views;
    _api_xsfr_token;
    _views_xsfr_token;
    // #endregion
    // #region Properties
    get api() {
        return this._api;
    }
    get sts() {
        return this._sts;
    }
    get views() {
        return this._views;
    }
    // #endregion
    // #region Constructor
    constructor() {
        //Sts
        this._sts = axios.create({
            baseURL: appHost.config.stsUrl,
            withCredentials: true,
        });
        //Init
        this._api = axios.create({
            baseURL: appHost.config.apiUrl,
            withCredentials: true,
        });
        this._views = axios.create({
            baseURL: appHost.config.viewsUrl,
            withCredentials: true,
            headers: {
                "X-Requested-With": "XMLHttpRequest",
            }
        });
        //Interceptors        
        this._api.interceptors.request.use((value) => this.OnRequestApi(value));
        this._api.interceptors.response.use((value) => this.OnResponseApi(value), undefined);
        this._views.interceptors.request.use((value) => this.OnRequestViews(value));
        this._views.interceptors.response.use((value) => this.OnResponseViews(value), undefined);
    }
    // #endregion
    // #region Interceptors
    async OnRequestApi(config) {
        if (this._api_xsfr_token) {
            if (config.headers === undefined) {
                config.headers = {};
            }
            config.headers.requestverificationtoken = this._api_xsfr_token;
        }
        return config;
    }
    async OnResponseApi(response) {
        if (response.headers.requestverificationtoken) {
            this._api_xsfr_token = response.headers.requestverificationtoken;
        }
        return response;
    }
    async OnRequestViews(config) {
        if (this._views_xsfr_token) {
            if (config.headers === undefined) {
                config.headers = {};
            }
            config.headers.requestverificationtoken = this._views_xsfr_token;
        }
        return config;
    }
    async OnResponseViews(response) {
        if (response.headers.requestverificationtoken) {
            this._views_xsfr_token = response.headers.requestverificationtoken;
        }
        return response;
    }
}
